import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import colorStyle from '@/components/mapv2/colorstyle';
import draggable from 'vuedraggable';
import { mapState, mapGetters, mapMutations } from 'vuex';
let _ = require('lodash');
export default {
  name: 'mapshadow',
  props: {
    value: {
      type: Object,
      default: {}
    }
  },
  components: {
    colorStyle,
    draggable
  },
  data() {
    return {
      min: -100,
      max: 100,
      shadowFlag: false,
      // 投影列表及配置显隐
      // 当前投影参数项
      form: {
        fillStyle: 'rgba(0, 0, 0, 0.1)',
        lineWidth: 0,
        lineDash: '0',
        strokeStyle: 'rgba(0, 0, 0, 0.1)',
        y: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        shadowColor: 'rgba(0, 0, 0, 0.1)'
      },
      // 默认投影参数项
      defaultform: {
        fillStyle: 'rgba(43, 103, 255, 0.2)',
        lineWidth: 1,
        lineDash: '0',
        strokeStyle: 'rgba(43, 103, 255, 1)',
        y: 5,
        shadowOffsetX: 0,
        shadowOffsetY: 2,
        shadowBlur: 2,
        shadowColor: 'rgba(43, 103, 255, 0.2)'
      },
      // 边框样式线的种类
      lineDashList: [{
        label: '实线',
        value: '0'
      }, {
        label: '短虚线',
        value: '5,3'
      }, {
        label: '中虚线',
        value: '10,5'
      }, {
        label: '长虚线',
        value: '20,10'
      }],
      shadowList: [],
      // 投影数据集合
      showParams: false,
      // 投影参数显隐
      originalShadowList: [],
      // 初始投影子表单数据
      outerStyle: {} // 投影DOM固定位置left/top
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          console.log(`mapshadow watch`);
          console.log(`this.form`, val);
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      console.log(`mapshadow mounted`);
      console.log(`this.form`, this.value);
      if (this.value.viewShadow && this.value.viewShadow === '显示') this.shadowFlag = true;
      console.log(`this.shadowFlag`, this.shadowFlag);
      console.log(`this.value.mapShadow`, this.value.mapShadow);
      this.originalShadowList = this.value.mapShadow;
      this.shadowList = this.value.mapShadow.map(item => {
        let obj = {};
        item.forEach(child => {
          obj[child.alias] = child.values[0] && child.values[0].val ? child.compt === 'numberinput' ? Number(child.values[0].val) : child.values[0].val : '';
        });
        let isAllempty = Object.keys(obj).every(key => {
          const value = obj[key];
          return value === null || value === undefined || value === '';
        });
        // 初次判断对象都为空 若为空 则初始化默认值
        if (isAllempty) obj = _.cloneDeep(this.defaultform);
        return obj;
      });
      console.log(`this.shadowList`, this.shadowList);
    });
  },
  methods: {
    /**
     * 切换显示投影复选框事件
     * @date 2025-06-26
     */
    isShowShadow(val) {
      console.log(`val`, val);
      this.setShadowList();
    },
    /**
     * 配置项变化事件
     * @param {Object} val 数据
     * @param {String} type 参数项名称
     * @date 2025-06-25
     */
    shadowChange(val, type) {
      console.log(`----- shadowChange -----`);
      console.log(val);
      console.log(type);
      if (type === 'fillStyle' || type === 'strokeStyle' || type === 'shadowColor') this.form[type] = val;
      console.log(this.form);
      console.log(`this.shadowList`, this.shadowList);
      this.setShadowList();
    },
    /**
     * 添加配置项条目
     * @param {Object} val 数据
     * @date 2025-06-25
     */
    addShadow() {
      this.shadowList.push({
        ...this.defaultform
      });
      this.setShadowList();
    },
    onEnd(val) {},
    /**
     * 投影点击事件
     * @param {Object} val 数据
     * @param {Number} index 索引
     * @date 2025-06-25
     */
    itemClick(val, index) {
      this.showParams = true;
      // 计算弹窗位置
      const itemDom = document.querySelector(`.slistitem${index}`);
      const itemRect = itemDom.getBoundingClientRect();
      this.outerStyle.left = `${itemRect.left}px`;
      this.outerStyle.top = `${itemRect.top - 400}px`;
      this.form = this.shadowList[index];
    },
    /**
     * 投影删除事件
     * @param {Number} index 索引
     * @date 2025-06-25
     */
    deleteItem(index) {
      this.shadowList.splice(index, 1);
      this.setShadowList();
    },
    /**
     * 投影复制事件
     * @param {Number} index 索引
     * @date 2025-06-26
     */
    copyItem(index) {
      this.shadowList.push({
        ...this.shadowList[index]
      });
      this.setShadowList();
    },
    setShadowList() {
      const changeList = this.shadowList.map(item => {
        let strcutArr = _.cloneDeep(this.originalShadowList[0]);
        Object.keys(item).forEach(elem => {
          strcutArr.forEach(child => {
            if (child.alias === elem) child.values = [{
              val: item[elem]
            }];
          });
        });
        return strcutArr;
      });
      console.log(`changeList`, changeList);
      this.$emit('change', {
        shadowFlag: this.shadowFlag,
        data: changeList
      });
    }
  }
};